module.exports = __webpack_public_path__ + "static/media/tavuk1.bc6b88b7.png";